/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CashbackShow_cashback$ref: FragmentReference;
declare export opaque type CashbackShow_cashback$fragmentType: CashbackShow_cashback$ref;
export type CashbackShow_cashback = {|
  +id: string,
  +date: any,
  +name: string,
  +rate: ?string,
  +amount: number,
  +source: string,
  +pended: boolean,
  +plaidTransactionId: ?string,
  +transactionAmount: ?number,
  +fastCashId: ?string,
  +state: ?string,
  +quarantinedReason: ?string,
  +availableStates: ?$ReadOnlyArray<string>,
  +userAuth0Id: ?string,
  +$refType: CashbackShow_cashback$ref,
|};
export type CashbackShow_cashback$data = CashbackShow_cashback;
export type CashbackShow_cashback$key = {
  +$data?: CashbackShow_cashback$data,
  +$fragmentRefs: CashbackShow_cashback$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CashbackShow_cashback",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pended",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plaidTransactionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fastCashId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quarantinedReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableStates",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userAuth0Id",
      "storageKey": null
    }
  ],
  "type": "Cashback"
};
// prettier-ignore
(node/*: any*/).hash = '59187f5122e2e81255ff06640951cf63';

module.exports = node;
